import ReactHtmlParser from 'react-html-parser';
export default ReactHtmlParser;
